const translation = {
  toVerifiedTip: {
    end: 'для профессионального плана Dify.',
    front: 'Теперь вы имеете право на статус "Проверенное образование". Пожалуйста, введите свои образовательные данные ниже, чтобы завершить процесс и получить',
    coupon: 'эксклюзивный 100% купон',
  },
  form: {
    schoolName: {
      title: 'Название вашей школы',
      placeholder: 'Введите официальное, полное название вашей школы',
    },
    schoolRole: {
      option: {
        student: 'Студент',
        teacher: 'Учитель',
        administrator: 'Школьный администратор',
      },
      title: 'Ваша школьная роль',
    },
    terms: {
      desc: {
        termsOfService: 'Условия обслуживания',
        front: 'Ваша информация и использование статуса Проверенное образование подлежат нашим',
        privacyPolicy: 'Политика конфиденциальности',
        and: 'и',
        end: '. Отправляя:',
      },
      option: {
        age: 'Я подтверждаю, что мне не меньше 18 лет',
        inSchool: 'Я подтверждаю, что я зачислен или работаю в указанной учреждении. Dify может запросить подтверждение зачисления/трудоустройства. Если я неправильно укажу свою правообладанность, я согласен оплатить любые сборы, которые изначально были отменены на основании моего образовательного статуса.',
      },
      title: 'Условия и соглашения',
    },
  },
  submit: 'Отправить',
  rejectTitle: 'Ваша образовательная проверка Dify была отклонена',
  currentSigned: 'В ДАННЫЙ МОМЕНТ ВХОД В ПРОФИЛЬ КАК',
  toVerified: 'Получите подтверждение образования',
  learn: 'Узнайте, как получить подтверждение образования',
  submitError: 'Отправка формы не удалась. Пожалуйста, попробуйте позже.',
  successTitle: 'Вы получили подтвержденное образование Dify',
  emailLabel: 'Ваш текущий адрес электронной почты',
  rejectContent: 'К сожалению, вы не имеете права на статус Проверенного образованием и, следовательно, не можете получить эксклюзивный купон на 100% для профессионального плана Dify, если вы используете этот адрес электронной почты.',
  successContent: 'Мы выдали купон на 100% скидку на план Dify Professional для вашего аккаунта. Купон действителен в течение одного года, пожалуйста, используйте его в течение срока действия.',
}

export default translation
